import { connect } from 'react-redux';
import { getSelected } from '../../single-choice/utils/selection';
import { CANCEL_FOR_ANY_REASON } from '../../products';
import MainCancelForAnyReason from './MainCancelForAnyReason';
import { jsx as _jsx } from "react/jsx-runtime";
const CancelForAnyReason = props => {
  return /*#__PURE__*/_jsx(MainCancelForAnyReason, {
    ...props
  });
};
const mapStateToProps = (state, _ref) => {
  let {
    form
  } = _ref;
  const productName = CANCEL_FOR_ANY_REASON.name;
  return {
    isSelected: getSelected(productName, form)(state)
  };
};
export default connect(mapStateToProps)(CancelForAnyReason);
//# sourceMappingURL=CancelForAnyReason.js.map